export const MOCK_COMPONENT_DEFINITION = {
  'createdDate': '2025-07-04T00:31:15.177Z',
  'createdBy': 'Tansel Ozkusaksiz',
  'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
  'updatedDate': '2025-07-04T00:34:04.447Z',
  'updatedBy': null,
  'updatedById': null,
  'isUpdatable': true,
  'isDeleted': false,
  'isDeletable': true,
  'id': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
  'className': 'RapiderComponente34b57044e8540b8824bbd6cb9858074',
  'selector': 'rapider-component-e34b5704-4e85-40b8-824b-bd6cb9858074',
  'moduleName': 'RapiderComponentModulee34b57044e8540b8824bbd6cb9858074',
  'title': 'Country Card',
  'description': 'A presentational component to display country information using ng-zorro card.',
  'defaultInputs': {
    'country': 'Vietnam',
    'capital': 'Hanoi',
    'currency': 'Vietnamese Dong',
    'population': 97338579,
    'latitude': 14.0583,
    'longitude': 108.2772,
    'continent': 'Asia',
    'flagImageUrl': 'https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg'
  },
  'isDeprecated': false,
  'isIterative': false,
  'buildStatus': 'successful',
  'files': [
    {
      'name': 'app-country-card.component.ts'
    },
    {
      'name': 'app-country-card.component.html'
    },
    {
      'name': 'app-country-card.component.scss'
    }
  ],
  'packageName': '@rapider/project-components',
  'categoryId': '98a8818a-278c-43ae-979a-2148625b2db3',
  'inputsTypeId': '5767df61-d99a-4c09-9fb2-0d06e4d5f6e9',
  'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
  'mainCategory': {
    'createdDate': '2025-02-18T11:30:22.812Z',
    'createdBy': 'Abdullah Serhat Ince',
    'createdById': '0f494ae6-b5c6-4394-a3c3-c7fca8d36706',
    'isUpdatable': false,
    'isDeleted': false,
    'isDeletable': false,
    'id': '98a8818a-278c-43ae-979a-2148625b2db3',
    'title': 'ClientGenerated',
    'name': 'ClientGenerated',
    'type': 'COMPONENT_DEFINITION',
    'description': 'A Client-Generated Component refers to a UI component that is dynamically created on the client side.'
  },
  'inputDefinitions': [
    {
      'createdDate': '2025-07-04T00:31:15.434Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': '7f656b29-b8a9-4600-9a17-53deeb2c7dce',
      'description': 'The name of the country.',
      'category': 'country',
      'title': 'country',
      'fieldName': 'country',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'textbox',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
      'fieldId': '8063a3dd-3e35-48f1-9160-2f110a3d120c',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
        'name': 'string',
        'isPrimitive': true,
        'type': 'primitive'
      }
    },
    {
      'createdDate': '2025-07-04T00:31:15.436Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': 'f1ee79fc-9944-47a7-b063-f3f007554cae',
      'description': 'The capital city of the country.',
      'category': 'capital',
      'title': 'capital',
      'fieldName': 'capital',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'textbox',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
      'fieldId': '183f3eb1-ea31-4391-89bf-8203dc604279',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
        'name': 'string',
        'isPrimitive': true,
        'type': 'primitive'
      }
    },
    {
      'createdDate': '2025-07-04T00:31:15.436Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': '08a43484-e00d-4cfe-8f8a-e37568685aa5',
      'description': 'The currency used in the country.',
      'category': 'currency',
      'title': 'currency',
      'fieldName': 'currency',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'textbox',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
      'fieldId': '98ae91c0-e60b-4449-a9d9-0f0e15775e38',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
        'name': 'string',
        'isPrimitive': true,
        'type': 'primitive'
      }
    },
    {
      'createdDate': '2025-07-04T00:31:15.438Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': 'ae180517-361e-4842-aab0-a07b64527040',
      'description': 'The latitude coordinate of the country.',
      'category': 'latitude',
      'title': 'latitude',
      'fieldName': 'latitude',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'number',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '58837f88-c089-459f-bf53-f3ddbaef2d1c',
      'fieldId': '6d96f15b-b038-45ae-91be-c87d9a7b4637',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '58837f88-c089-459f-bf53-f3ddbaef2d1c',
        'name': 'number',
        'isPrimitive': true
      }
    },
    {
      'createdDate': '2025-07-04T00:31:15.437Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': '0069bb0b-f9cd-40db-9c70-2172bd4fb4aa',
      'description': 'The population of the country.',
      'category': 'population',
      'title': 'population',
      'fieldName': 'population',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'number',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '58837f88-c089-459f-bf53-f3ddbaef2d1c',
      'fieldId': 'e220de4f-6b09-4f03-bb69-a30f669235df',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '58837f88-c089-459f-bf53-f3ddbaef2d1c',
        'name': 'number',
        'isPrimitive': true
      }
    },
    {
      'createdDate': '2025-07-04T00:31:15.438Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': 'd60f22e2-814e-4dd0-85e5-d0208c8e484b',
      'description': 'The longitude coordinate of the country.',
      'category': 'longitude',
      'title': 'longitude',
      'fieldName': 'longitude',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'number',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '58837f88-c089-459f-bf53-f3ddbaef2d1c',
      'fieldId': '63e9ed83-9eb4-41a0-a49f-94fc58487f07',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '58837f88-c089-459f-bf53-f3ddbaef2d1c',
        'name': 'number',
        'isPrimitive': true
      }
    },
    {
      'createdDate': '2025-07-04T00:31:15.439Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': '5a9e7f50-b643-4237-af10-62ff11414380',
      'description': 'The continent where the country is located.',
      'category': 'continent',
      'title': 'continent',
      'fieldName': 'continent',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'textbox',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
      'fieldId': '78b2718d-875b-4d2f-94be-1c0e5d4a4914',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
        'name': 'string',
        'isPrimitive': true,
        'type': 'primitive'
      }
    },
    {
      'createdDate': '2025-07-04T00:31:15.439Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': '0ecb35ad-9301-423b-8059-4d3f67d0110f',
      'description': 'The URL of the country\'s flag image.',
      'category': 'flagImageUrl',
      'title': 'flagImageUrl',
      'fieldName': 'flagImageUrl',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'textbox',
      'isArray': false,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'typeId': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
      'fieldId': '751c3dcd-d37a-4fa1-b50d-458578d10126',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2020-05-01T00:00:00.001Z',
        'isUpdatable': false,
        'isDeletable': false,
        'id': '64b0d7a0-5258-4b54-a8fe-475fc8d9bda1',
        'name': 'string',
        'isPrimitive': true,
        'type': 'primitive'
      }
    }
  ],
  'samples': [
    {
      'createdDate': '2025-07-04T00:31:15.186Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': '8c2f89bf-9274-4ab4-bc65-463cce0e9eec',
      'title': 'Country Card',
      'description': 'A presentational component to display country information using ng-zorro card.',
      'inputs': {
        'country': 'Vietnam',
        'capital': 'Hanoi',
        'currency': 'Vietnamese Dong',
        'population': 97338579,
        'latitude': 14.0583,
        'longitude': 108.2772,
        'continent': 'Asia',
        'flagImageUrl': 'https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg'
      },
      'index': 0,
      'componentDefinitionId': 'e34b5704-4e85-40b8-824b-bd6cb9858074',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e'
    }
  ]
};


export const MOCK_FOOTBALL_COMPONENT_DEFINITION = {
  'createdDate': '2025-07-04T01:57:22.617Z',
  'createdBy': 'Tansel Ozkusaksiz',
  'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
  'isUpdatable': true,
  'isDeleted': false,
  'isDeletable': true,
  'id': 'fe90c35c-7026-4139-af14-2ecb8054db03',
  'className': 'RapiderComponentfe90c35c70264139af142ecb8054db03',
  'selector': 'rapider-component-fe90c35c-7026-4139-af14-2ecb8054db03',
  'moduleName': 'RapiderComponentModulefe90c35c70264139af142ecb8054db03',
  'title': 'Football Player Card List',
  'description': 'A component that displays a list of football players, each on a separate card using ng-zorro-antd components.',
  'defaultInputs': {
    'players': [
      {
        'player_name': 'Lionel Messi',
        'profile_picture_url': 'https://www.gettyimages.com/photos/lionel-messi',
        'full_name': 'Lionel Andrés Messi',
        'date_of_birth': 'June 24, 1987',
        'place_of_birth': 'Rosario, Argentina',
        'height': '1.70 m (5 ft 7 in)',
        'positions': [
          'Forward'
        ],
        'current_team': 'Inter Miami CF',
        'current_number': 10,
        'statistics': {
          'games_played': 28,
          'context_games_played': 'Major League Soccer',
          'goals': 20,
          'context_goals': 'Major League Soccer',
          'assists': 15,
          'context_assists': 'Major League Soccer',
          'yellow_cards': 3,
          'context_yellow_cards': 'Major League Soccer',
          'red_cards': 0,
          'context_red_cards': 'Major League Soccer'
        }
      },
      {
        'player_name': 'Cristiano Ronaldo',
        'profile_picture_url': 'https://www.gettyimages.com/photos/cristiano-ronaldo',
        'full_name': 'Cristiano Ronaldo dos Santos Aveiro',
        'date_of_birth': 'February 5, 1985',
        'place_of_birth': 'Funchal, Madeira, Portugal',
        'height': '1.87 m (6 ft 1 in)',
        'positions': [
          'Forward'
        ],
        'current_team': 'Al Nassr FC',
        'current_number': 7,
        'statistics': {
          'games_played': 30,
          'context_games_played': 'Saudi Pro League',
          'goals': 25,
          'context_goals': 'Saudi Pro League',
          'assists': 8,
          'context_assists': 'Saudi Pro League',
          'yellow_cards': 4,
          'context_yellow_cards': 'Saudi Pro League',
          'red_cards': 1,
          'context_red_cards': 'Saudi Pro League'
        }
      },
      {
        'player_name': 'Kylian Mbappé',
        'profile_picture_url': 'https://www.gettyimages.com/photos/kylian-mbappe',
        'full_name': 'Kylian Mbappé Lottin',
        'date_of_birth': 'December 20, 1998',
        'place_of_birth': 'Paris, France',
        'height': '1.78 m (5 ft 10 in)',
        'positions': [
          'Forward'
        ],
        'current_team': 'Paris Saint-Germain',
        'current_number': 7,
        'statistics': {
          'games_played': 29,
          'context_games_played': 'Ligue 1',
          'goals': 23,
          'context_goals': 'Ligue 1',
          'assists': 12,
          'context_assists': 'Ligue 1',
          'yellow_cards': 2,
          'context_yellow_cards': 'Ligue 1',
          'red_cards': 0,
          'context_red_cards': 'Ligue 1'
        }
      }
    ]
  },
  'isDeprecated': false,
  'isIterative': false,
  'files': [
    {
      'name': 'app-football-player-card-list.component.ts'
    },
    {
      'name': 'app-football-player-card-list.component.html'
    },
    {
      'name': 'app-football-player-card-list.component.scss'
    }
  ],
  'packageName': '@rapider/project-components',
  'categoryId': '98a8818a-278c-43ae-979a-2148625b2db3',
  'inputsTypeId': 'eb8a8c6b-cdfd-4cb7-9eb3-57dd862ed859',
  'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
  'samples': [
    {
      'createdDate': '2025-07-04T01:57:22.625Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': 'c7c0751b-e933-4c7d-9e41-32b5df75f873',
      'title': 'Football Player Card List',
      'description': 'A component that displays a list of football players, each on a separate card using ng-zorro-antd components.',
      'inputs': {
        'players': [
          {
            'player_name': 'Lionel Messi',
            'profile_picture_url': 'https://www.gettyimages.com/photos/lionel-messi',
            'full_name': 'Lionel Andrés Messi',
            'date_of_birth': 'June 24, 1987',
            'place_of_birth': 'Rosario, Argentina',
            'height': '1.70 m (5 ft 7 in)',
            'positions': [
              'Forward'
            ],
            'current_team': 'Inter Miami CF',
            'current_number': 10,
            'statistics': {
              'games_played': 28,
              'context_games_played': 'Major League Soccer',
              'goals': 20,
              'context_goals': 'Major League Soccer',
              'assists': 15,
              'context_assists': 'Major League Soccer',
              'yellow_cards': 3,
              'context_yellow_cards': 'Major League Soccer',
              'red_cards': 0,
              'context_red_cards': 'Major League Soccer'
            }
          },
          {
            'player_name': 'Cristiano Ronaldo',
            'profile_picture_url': 'https://www.gettyimages.com/photos/cristiano-ronaldo',
            'full_name': 'Cristiano Ronaldo dos Santos Aveiro',
            'date_of_birth': 'February 5, 1985',
            'place_of_birth': 'Funchal, Madeira, Portugal',
            'height': '1.87 m (6 ft 1 in)',
            'positions': [
              'Forward'
            ],
            'current_team': 'Al Nassr FC',
            'current_number': 7,
            'statistics': {
              'games_played': 30,
              'context_games_played': 'Saudi Pro League',
              'goals': 25,
              'context_goals': 'Saudi Pro League',
              'assists': 8,
              'context_assists': 'Saudi Pro League',
              'yellow_cards': 4,
              'context_yellow_cards': 'Saudi Pro League',
              'red_cards': 1,
              'context_red_cards': 'Saudi Pro League'
            }
          },
          {
            'player_name': 'Kylian Mbappé',
            'profile_picture_url': 'https://www.gettyimages.com/photos/kylian-mbappe',
            'full_name': 'Kylian Mbappé Lottin',
            'date_of_birth': 'December 20, 1998',
            'place_of_birth': 'Paris, France',
            'height': '1.78 m (5 ft 10 in)',
            'positions': [
              'Forward'
            ],
            'current_team': 'Paris Saint-Germain',
            'current_number': 7,
            'statistics': {
              'games_played': 29,
              'context_games_played': 'Ligue 1',
              'goals': 23,
              'context_goals': 'Ligue 1',
              'assists': 12,
              'context_assists': 'Ligue 1',
              'yellow_cards': 2,
              'context_yellow_cards': 'Ligue 1',
              'red_cards': 0,
              'context_red_cards': 'Ligue 1'
            }
          }
        ]
      },
      'index': 0,
      'componentDefinitionId': 'fe90c35c-7026-4139-af14-2ecb8054db03',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e'
    }
  ],
  'inputDefinitions': [
    {
      'createdDate': '2025-07-04T01:57:22.825Z',
      'createdBy': 'Tansel Ozkusaksiz',
      'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
      'isUpdatable': true,
      'isDeleted': false,
      'isDeletable': true,
      'id': '6268c498-5ebc-4e56-bd22-e61a31b5d1a4',
      'description': 'List of football players to display on cards.',
      'category': 'players',
      'title': 'players',
      'fieldName': 'players',
      'isVisible': true,
      'attributeBinding': true,
      'uiDataSelector': 'monaco-code-editor',
      'isArray': true,
      'componentDefinitionId': 'fe90c35c-7026-4139-af14-2ecb8054db03',
      'typeId': 'b0bb07cd-1212-4130-81b0-72eeb147c515',
      'fieldId': '8654e7b0-af39-48ff-bf5a-eef3681312ca',
      'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
      'type': {
        'createdDate': '2025-07-04T01:57:22.452Z',
        'createdBy': 'Tansel Ozkusaksiz',
        'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
        'isUpdatable': true,
        'isDeleted': false,
        'isDeletable': true,
        'id': 'b0bb07cd-1212-4130-81b0-72eeb147c515',
        'name': 'playersConfig',
        'isPrimitive': false,
        'category': 'component-config',
        'type': 'model',
        'description': 'List of football players to display on cards.',
        'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
        'fields': [
          {
            'createdDate': '2025-07-04T01:57:22.592Z',
            'createdBy': 'Tansel Ozkusaksiz',
            'createdById': 'e995822b-f88d-40ef-86df-0f07cb1149d8',
            'isUpdatable': true,
            'isDeleted': false,
            'isDeletable': true,
            'id': '92b8c112-a865-4c5f-9600-518ce10df7da',
            'description': 'A football player object',
            'name': 'player',
            'isArray': false,
            'isRequired': true,
            'isNavigationalProperty': false,
            'uiDataSelector': 'monaco-code-editor',
            'uiDataSelectorSettings': {
              'sizeSettings': {
                'width': '300px'
              }
            },
            'projectId': '2596cbc4-c2f5-4441-8b71-9a833735664e',
            'parentDataSchemaId': 'b0bb07cd-1212-4130-81b0-72eeb147c515',
            'typeId': 'ac54ce88-24ef-40a5-8403-3f88a4537a85',
            'type': {
              'createdDate': '2020-05-01T00:00:00.001Z',
              'isUpdatable': false,
              'isDeletable': false,
              'id': 'ac54ce88-24ef-40a5-8403-3f88a4537a85',
              'name': 'object',
              'isPrimitive': true
            }
          }
        ]
      }
    }
  ],
  'mainCategory': {
    'createdDate': '2025-02-18T11:30:22.812Z',
    'createdBy': 'Abdullah Serhat Ince',
    'createdById': '0f494ae6-b5c6-4394-a3c3-c7fca8d36706',
    'isUpdatable': false,
    'isDeleted': false,
    'isDeletable': false,
    'id': '98a8818a-278c-43ae-979a-2148625b2db3',
    'title': 'ClientGenerated',
    'name': 'ClientGenerated',
    'type': 'COMPONENT_DEFINITION',
    'description': 'A Client-Generated Component refers to a UI component that is dynamically created on the client side.'
  }
};
